// "¿Qué vendes?" (sql/144): decide qué partes del menú ve el negocio.
// No borra nada: si cambia de opción, todo vuelve a aparecer con sus datos.

export const OPCIONES_VENDE = [
  { clave: 'productos', label: 'Productos', emoji: '🛍️', ayuda: 'Inventario, pedidos y catálogo de productos.' },
  { clave: 'servicios', label: 'Servicios', emoji: '💼', ayuda: 'Servicios, cotizaciones, agenda y órdenes.' },
  { clave: 'ambos', label: 'Productos y servicios', emoji: '🛍️💼', ayuda: 'Todo el menú.' },
];

const valido = (v) => (['productos', 'servicios', 'ambos'].includes(v) ? v : 'ambos');
export const usaProductos = (vende) => valido(vende) !== 'servicios';
export const usaServicios = (vende) => valido(vende) !== 'productos';
